import { Component } from "@angular/core";

@Component({
    selector: 'unh-fake-project-post-item',
    templateUrl: './fake-project-post-item.html',
    styleUrls: ['./fake-project-post-item.scss']
})
export class FakeProjectPostItem {}